// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3yRCn","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3AHJW"};